import { render, staticRenderFns } from "./MultiDomainModal.vue?vue&type=template&id=864d15be&scoped=true"
import script from "./MultiDomainModal.vue?vue&type=script&lang=js"
export * from "./MultiDomainModal.vue?vue&type=script&lang=js"
import style0 from "./MultiDomainModal.vue?vue&type=style&index=0&id=864d15be&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864d15be",
  null
  
)

export default component.exports